<template>
    <div>
        <kt-nav space="md" size="lg" id="kt-nav">
            <form @submit.prevent="searchIpAction" id="searchByIp_form">
                <kt-nav-item>
                    <div class="accordion accordion-toggle-arrow" id="searchByIp">
                        <div class="card" style="overflow:inherit">
                            <div class="card-header bg-transparent" id="headingOne">
                                <div class="card-title collapsed" data-toggle="collapse"
                                     data-target="#searchIp"
                                     aria-controls="searchIp">
                                    {{ $t('security.searchByIp') }}
                                </div>
                            </div>
                            <div id="searchIp" class="collapse" aria-labelledby="searchIp" data-parent="#searchByIp">
                                <div class="card-body">
                                    <kt-form-section>
                                        <kt-form-row>
                                            <kt-col xs="12" sm="12" md="6" lg="6">
                                                <kt-form-group>
                                                    <kt-form-label for="Ip_address">
                                                        {{ $t('security.Ip_address') }}
                                                    </kt-form-label>
                                                    <kt-form-control
                                                        ref="Ip_address"
                                                        dir="ltr"
                                                        name="Ip_address"
                                                        id="Ip_address"
                                                        v-model="Ip_address"
                                                    />
                                                </kt-form-group>
                                            </kt-col>
                                        </kt-form-row>
                                    </kt-form-section>
                                    <kt-form-section>
                                        <button class="btn btn-success btn-wide" id="searchIp_btn">
                                            {{ $t('security.search') }}
                                        </button>
                                    </kt-form-section>
                                </div>
                            </div>
                        </div>
                    </div>
                </kt-nav-item>
            </form>

            <form @submit.prevent="searchPhoneAction" id="searchByUserPhone_form">
                <kt-nav-item>
                    <div class="accordion accordion-toggle-arrow" id="searchByUserPhone">
                        <div class="card" style="overflow:inherit">
                            <div class="card-header bg-transparent" id="headingTwo">
                                <div class="card-title collapsed" data-toggle="collapse"
                                     data-target="#searchUserPhone"
                                     aria-controls="searchUserPhone">
                                    {{ $t('security.searchByUserPhone') }}
                                </div>
                            </div>
                            <div
                                id="searchUserPhone"
                                class="collapse"
                                aria-labelledby="searchUserPhone"
                                data-parent="#searchByUserPhone"
                            >
                                <div class="card-body">
                                    <kt-form-section>
                                        <kt-form-row>
                                            <kt-col xs="12" sm="12" md="6" lg="6">
                                                <kt-form-group>
                                                    <kt-form-label for="user_phone">
                                                        {{ $t('security.user_phone') }}
                                                    </kt-form-label>
                                                    <kt-form-control
                                                        ref="user_phone"
                                                        dir="ltr"
                                                        name="user_phone"
                                                        id="user_phone"
                                                        v-model="User_phone"
                                                    />
                                                </kt-form-group>
                                            </kt-col>
                                        </kt-form-row>
                                    </kt-form-section>
                                    <kt-form-section>
                                        <button class="btn btn-success btn-wide" id="searchUserPhone_btn">
                                            {{ $t('security.search') }}
                                        </button>
                                    </kt-form-section>
                                </div>
                            </div>
                        </div>
                    </div>
                </kt-nav-item>
            </form>
        </kt-nav>
    <kt-datatable  v-bind="datatableProps" ref="datatable"></kt-datatable>
    </div>
</template>

<script>
    import columns from './../datatable/columns'
    import { ApiUrl } from '@/common/api.service'
    import { AuthorizationHeader } from '@/common/jwt.service'
    import actionsColumn from './actions-column'
    import $ from "jquery";

    export default {

        data() {
            return {
                Ip_address: null,
                User_phone: null,
                query: {}
            }
        },
        computed: {
            datatableProps() {
                return {
                    id: "search_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path('blackList/search'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: function(res) {
                                    return res.data.data
                                },
                                params: {
                                    query: this.query
                                },
                            },
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {
                    },
                    pagination: false,
                    sortable: true,
                    columns: columns,
                    actions: actionsColumn
                }
            }
        },
        methods: {
            searchIpAction() {
                let form = $('#searchByIp_form')
                let btn = $('#searchIp_btn')

                form.validate( {
                    rules: {
                        Ip_address: {
                            required: true
                        },
                    }
                })

                if(!form.valid()) {
                    return
                }

                this.query = {
                    'Ip_address': this.Ip_address
                }
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
            },
            searchPhoneAction() {
                let form = $('#searchByUserPhone_form')
                let btn = $('#searchUserPhone_btn')

                form.validate( {
                    rules: {
                        User_phone: {
                            required: true
                        },
                    }
                })

                if(!form.valid()) {
                    return
                }
                this.query = {
                    'phone': this.User_phone
                }
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
            }
        }
    }
</script>